export default __webpack_public_path__ + "static/media/unipack-brochure.476d7bd2.pdf";